export default () => ({
  password: {
    width: 350,
    marginBottom: 15
  },
  backToSignIn: {
    fontSize: 11
  }
});
